/**
 * Created by hb on 2019/5/6.
 */

import Vue from 'vue'
import _ from 'lodash'
import { flightCities } from '@/assets/js/data'
import { Popover } from 'ant-design-vue'
Vue.use(Popover)

export default {
  name: 'l8-flightcityselector',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    placeholder: String,
    value: String,
    size: {
      type: String,
      default: 'default'
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    open: {
      type: Boolean
    }
  },
  data () {
    return {
      // 原始城市数据
      citiesData: [],
      // 城市选择框每个tab的数据
      cities4Tab: {
        inner: [],
        outer: []
      },
      // 搜索总结果集合
      cities4Search: [],
      cities4SearchOnePage: [], // 搜索单页结果集合
      cities4SearchPageSize: 12, // 搜索单页大小
      cities4SearchCurrentPage: 1, // 搜索当前页数
      cities4SearchTotalPage: 0, // 搜索总页数
      // 搜索分页器
      cities4Pager: [],
      cities4PagerOnePage: [],
      cities4PagerPageSize: 5,
      cities4PagerCurrentPage: 1,
      cities4PagerTotalPage: 0,
      hideCities4Pager: false,
      // tab分类
      tabType: [
        { name: '热门', highlight: 1, hot: true },
        { name: 'ABCDEF', highlight: 0 },
        { name: 'GHJKL', highlight: 0 },
        { name: 'MNQRT', highlight: 0 },
        { name: 'SWXYZ', highlight: 0 },
        { name: '港澳台及其他国家城市', highlight: 0, other: true }
      ],
      // 是否展示城市选择框
      showPanel: true,
      // 是否展示搜索框
      showSelect: false,
      // 是否展示国际航线
      isShowTabIntl: true,
      // 是否展示国际国内的title
      isShowCitiesTitle: false,
      label: '',
      // 下拉框提示文字
      selectTips: '输入中文/拼音/三字码或↑↓选择',
      visible: false
    }
  },
  watch: {
    value (newValue) {
      if (!newValue) {
        this.label = ''
      } else {
        const initCity = _.find(this.citiesData, {
          code: newValue
        })
        this.label = initCity ? initCity.city : ''
      }
    },
    open (newValue) {
      if (!newValue) {
        return
      }

      this.visible = newValue
      this.$refs.input.focus()
    }
  },
  created () {
    this.getData()
  },
  methods: {
    onKeyup (e) {
      const _this = this
      if (e.target.value.length < 1) {
        this.showPanel = true
        this.showSelect = false
        this.$emit('change', '')
        return
      }
      _this.search(e.target.value)
      _this.visible = true

      if (typeof (_this.$refs.citiesSearchUl) === 'undefined') {
        return
      }

      let lis = _this.$refs.citiesSearchUl.children

      if (e.keyCode === 40) {
        let iFindAdd = -1
        for (let i = 0; i < lis.length; i++) {
          if (lis[i].className === 'hover') {
            iFindAdd = i
            // 当前取消高亮
            lis[i].className = ''
          }
        }
        // 增一操作
        ++iFindAdd
        // 判断是否增一操作后越出数组界限
        iFindAdd = iFindAdd >= _this.cities4SearchOnePage.length ? 0 : iFindAdd
        // 下一个高亮
        lis[iFindAdd].className = 'hover'
        return false
      } else if (e.keyCode === 38) {
        let iFindMinus = -1
        for (let i = 0; i < lis.length; i++) {
          if (lis[i].className === 'hover') {
            iFindMinus = i
            // 当前取消高亮
            lis[i].className = ''
          }
        }
        // 减一操作
        --iFindMinus
        // 判断是否减一操作后越出数组界限
        iFindMinus = iFindMinus < 0 ? _this.cities4SearchOnePage.length - 1 : iFindMinus
        // 上一个高亮
        lis[iFindMinus].className = 'hover'
        return false
      } else if (e.keyCode === 13) {
        for (let i = 0; i < lis.length; i++) {
          if (lis[i].className === 'hover') {
            // 当前取消高亮
            this.searchChoose(this.cities4SearchOnePage[i])
            this.$refs.input.blur()
            break
          }
        }
      }
    },
    async getData () {
      const cities = await flightCities()

      if (cities) {
        this.citiesData = cities
        this.init()
      }
    },
    init () {
      this.$nextTick(() => {
        if (this.value) {
          const initCity = _.find(this.citiesData, {
            code: this.value
          })
          this.label = initCity ? initCity.city : ''
        }

        this.searchResult(this.citiesData)
        this.genTabs()
        this.getTabData(0)
      })
    },
    search (label) {
      const _this = this

      if (label.trim() === '') {
        _this.showSelect = false
        _this.showPanel = true
      } else {
        // 统一转换小写
        var value = label.toLowerCase()
        var result = _this.citiesData.filter(item => {
          var r1 = item.city.indexOf(value) > -1
          var r2 = item.pinyin.toLowerCase().indexOf(value) > -1
          var r3 = item.code.toLowerCase().indexOf(value) > -1
          if (r1 || r2 || r3) {
            return true
          }
        })
        // 找不到结果
        if (result.length === 0) {
          var tail = value.trim().length > 10 ? '...' : ''
          _this.selectTips = `抱歉，找不到含有“${value.trim().substring(0, 10) + tail}”的结果`
          _this.hideCities4Pager = true
        } else {
          _this.selectTips = '输入中文/拼音/三字码或↑↓选择'
          _this.hideCities4Pager = false
        }
        _this.searchResult(result)
        _this.showSelect = true
        _this.showPanel = false
      }
    },
    searchResult (data) {
      let _this = this
      // 初始化搜索框结果数据
      _this.cities4Search = data.map(ele => {
        return ele
      })
      _this.cities4Search.sort((a, b) => {
        return a.pinyin.charCodeAt(0) - b.pinyin.charCodeAt(0)
      })
      _this.cities4SearchCurrentPage = 1
      _this.cities4SearchTotalPage = Math.ceil(
        _this.cities4Search.length / _this.cities4SearchPageSize
      )
      _this.cities4SearchOnePage = _this.cities4Search.slice(
        0 + (_this.cities4SearchCurrentPage - 1) * _this.cities4SearchPageSize,
        _this.cities4SearchPageSize +
        (_this.cities4SearchCurrentPage - 1) * _this.cities4SearchPageSize
      )
      // 初始化分页器
      _this.cities4Pager = []
      for (var i = 1; i <= _this.cities4SearchTotalPage; i++) {
        _this.cities4Pager.push(i)
      }
      _this.cities4PagerCurrentPage = 1
      _this.cities4PagerTotalPage = Math.ceil(
        _this.cities4Pager.length / _this.cities4PagerPageSize
      )
      _this.cities4PagerOnePage = _this.cities4Pager.slice(
        0 + (_this.cities4PagerCurrentPage - 1) * _this.cities4PagerPageSize,
        _this.cities4PagerPageSize +
        (_this.cities4PagerCurrentPage - 1) * _this.cities4PagerPageSize
      )
    },
    genTabs () {
      let _this = this
      // 1、单独取出只含有letter、tab的数据map转换数据并按照tab升序排序
      let tabsData = _this.citiesData
        .map(ele => {
          return {
            letter: ele.letter,
            tab: ele.tab
          }
        })
        .sort((a, b) => {
          return a.tab - b.tab
        })
      let tabsMap = {}
      // 2、建立letter - tab的对应关系map并去重

      tabsData.forEach((ele, i) => {
        tabsMap[ele.letter] = ele.tab
      })
      let tabsArr = []
      // 3、反转建立tab - letter的对应关系，并用数据保存
      for (var p in tabsMap) {
        var index = tabsMap[p] - 0 // 强制转换数字
        if (_.isUndefined(tabsArr[index])) {
          tabsArr[index] = []
        }
        tabsArr[index].push(p)
      }

      // 4、构建tabType
      // tabType: [{name: '热门', highlight: 1, hot: true}, {name: 'ABCDEF', highlight: 0}, {name: 'GHJ', highlight: 0}, {name: 'KLMN', highlight: 0}, {name: 'PQST', highlight: 0}, {name: 'WXYZ', highlight: 0}],
      _this.tabType = [{ name: '热门', highlight: 1, hot: true }]
      for (let i = 1; i < tabsArr.length; i++) {
        tabsArr[i].sort((a, b) => {
          return a.charCodeAt(0) - b.charCodeAt(0)
        })
        _this.tabType.push({
          name: tabsArr[i].join(''),
          highlight: 0
        })
      }
      _this.tabType.push({
        name: '港澳台及其他国家城市',
        highlight: 0,
        other: true
      })
    },
    getTabData (index) {
      let _this = this

      _this.isShowTabIntl = index === 0
      _this.isShowCitiesTitle = index === 0

      var _data = []
      // 热门
      _data = _this.citiesData.filter(item => {
        // 热门数据
        var hot = _this.tabType[index].hot && !_.isUndefined(item.num)
        // 非热门数据
        var notHot = _this.tabType[index].name.indexOf(item.letter) > -1
        // 港澳台以及国际
        var other = _this.tabType[index].other && item.other

        return hot || notHot || other
      })

      // 统一整理数据格式
      // 1.排序
      if (!index) {
        _data.sort((a, b) => {
          return a.num - b.num
        })
      }
      // 2.区分国内、国际和地区两种城市
      _this.cities4Tab.outer = [] // 先清空数据集合
      _this.cities4Tab.inner = [] // 先清空数据集合
      _data.forEach((ele, i) => {
        [_this.cities4Tab.outer, _this.cities4Tab.inner][ele.other ? 0 : 1].push(ele)
      })

      // 如果不是热门，要进行首字母分组
      if (index) {
        _this.cities4Tab.outer.sort((a, b) => {
          return a.letter.charCodeAt(0) - b.letter.charCodeAt(0)
        })
        _this.cities4Tab.inner.sort((a, b) => {
          return a.letter.charCodeAt(0) - b.letter.charCodeAt(0)
        })
      }

      if (index && _this.cities4Tab.inner.length) {
        const group = _.groupBy(_this.cities4Tab.inner, 'letter')
        _this.cities4Tab.inner = Object.keys(group).map(key => {
          return {
            letter: key,
            list: group[key]
          }
        })
      }

      // 如果是国际、港澳台tab的话，那么就显示
      if (_this.tabType[index].other) {
        _this.isShowTabIntl = true
      }
    },
    tabChange (index) {
      let _this = this
      // 所有tab取消高亮
      _this.tabType = _this.tabType.map(function (ele) {
        return {
          name: ele.name,
          highlight: 0,
          hot: ele.hot,
          other: ele.other
        }
      })
      // 高亮当前的tab
      _this.tabType[index].highlight = 1
      // 展示城市选择框数据
      _this.getTabData(index)
      this.$refs.input.focus()
    },
    cities4PagerPrev () {
      let _this = this
      if (_this.cities4PagerCurrentPage === 1) {
        this.$refs.input.focus()
        return false
      }
      _this.cities4PagerCurrentPage--
      _this.cities4PagerOnePage = _this.cities4Pager.slice(
        0 + (_this.cities4PagerCurrentPage - 1) * _this.cities4PagerPageSize,
        _this.cities4PagerPageSize +
        (_this.cities4PagerCurrentPage - 1) * _this.cities4PagerPageSize
      )
      _this.cities4PagerCallback(
        0 + (_this.cities4PagerCurrentPage - 1) * _this.cities4PagerPageSize + 1
      )
    },
    cities4PagerNext () {
      let _this = this
      if (_this.cities4PagerCurrentPage === _this.cities4PagerTotalPage) {
        this.$refs.input.focus()
        return false
      }
      _this.cities4PagerCurrentPage++
      _this.cities4PagerOnePage = _this.cities4Pager.slice(
        0 + (_this.cities4PagerCurrentPage - 1) * _this.cities4PagerPageSize,
        _this.cities4PagerPageSize +
        (_this.cities4PagerCurrentPage - 1) * _this.cities4PagerPageSize
      )
      _this.cities4PagerCallback(
        0 + (_this.cities4PagerCurrentPage - 1) * _this.cities4PagerPageSize + 1
      )
    },
    cities4PagerCallback (page) {
      let _this = this
      _this.cities4SearchCurrentPage = page
      _this.cities4SearchOnePage = _this.cities4Search.slice(
        0 + (_this.cities4SearchCurrentPage - 1) * _this.cities4SearchPageSize,
        _this.cities4SearchPageSize +
        (_this.cities4SearchCurrentPage - 1) * _this.cities4SearchPageSize
      )
      this.$refs.input.focus()
    },
    searchChoose (item) {
      this.showPanel = true
      this.showSelect = false
      this.label = item.city
      this.$emit('change', item.code, item)
      this.visible = false
      this.$refs.input.blur()
    },
    onVisibleChange (visible) {
      if (!visible) {
        this.$emit('close')
      }
    }
  }
}
